import { useState } from 'react';

const useModal = () => {
  const [openModalComp, setOpenModal] = useState(false);
  const [idProd, setIdProd] = useState();
  const [status, setStatus] = useState('');
  const [reject, setReject] = useState(false);
  const [variant, setVariant] = useState();
  return [
    openModalComp,
    setOpenModal,
    idProd,
    setIdProd,
    status,
    setStatus,
    reject,
    setReject,
    variant,
    setVariant,
  ];
};

export default useModal;
